import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Report } from '../../../models/report.model';

@Component({
  selector: 'app-informations-bien-edit-mode',
  templateUrl: './informations-bien-edit-mode.component.html',
  styleUrls: ['./informations-bien-edit-mode.component.scss'],
})
export class InformationsBienEditModeComponent implements OnChanges {
  @Input() informationsBien!: Report.Property;

  @Output() informationsBienChanged = new EventEmitter<Report.Property>();

  informationsBienForm = new FormGroup({
    description: new FormControl(''),
    surroundingsDescription: new FormControl(''),
    viewingDate: new FormControl(''),
    occupation: new FormControl(''),
    condition: new FormControl(''),
    comments: new FormControl(''),
  });

  private newInformationsBien!: Report.Property;

  ngOnChanges(changes: SimpleChanges): void {
    const currentInformationsBien = changes['informationsBien'].currentValue;
    if (currentInformationsBien) {
      this.newInformationsBien = currentInformationsBien;
      this.setFormValues();
    }
  }

  descriptionChanged(event: Event) {
    this.newInformationsBien = {
      ...this.newInformationsBien,
      description: (event.target as HTMLInputElement).value,
    };

    this.informationsBienChanged.emit(this.newInformationsBien);
  }

  surroundingsDescriptionChanged(event: Event) {
    this.newInformationsBien = {
      ...this.newInformationsBien,
      surroundingsDescription: (event.target as HTMLInputElement).value,
    };

    this.informationsBienChanged.emit(this.newInformationsBien);
  }

  viewingDateChanged(event: Event) {
    this.newInformationsBien = {
      ...this.newInformationsBien,
      viewingDate: (event.target as HTMLInputElement).value,
    };

    this.informationsBienChanged.emit(this.newInformationsBien);
  }

  occupationChanged(event: Event) {
    this.newInformationsBien = {
      ...this.newInformationsBien,
      occupation: (event.target as HTMLInputElement).value,
    };

    this.informationsBienChanged.emit(this.newInformationsBien);
  }

  conditionChanged(event: Event) {
    this.newInformationsBien = {
      ...this.newInformationsBien,
      condition: (event.target as HTMLInputElement).value,
    };

    this.informationsBienChanged.emit(this.newInformationsBien);
  }

  commentsChanged(event: Event) {
    this.newInformationsBien = {
      ...this.newInformationsBien,
      comments: (event.target as HTMLInputElement).value,
    };

    this.informationsBienChanged.emit(this.newInformationsBien);
  }

  private setFormValues(): void {
    this.informationsBienForm.controls.description.setValue(
      this.informationsBien.description,
    );

    this.informationsBienForm.controls.surroundingsDescription.setValue(
      this.informationsBien.surroundingsDescription,
    );

    this.informationsBienForm.controls.viewingDate.setValue(
      this.informationsBien.viewingDate,
    );

    this.informationsBienForm.controls.occupation.setValue(
      this.informationsBien.occupation,
    );

    this.informationsBienForm.controls.condition.setValue(
      this.informationsBien.condition,
    );

    this.informationsBienForm.controls.comments.setValue(
      this.informationsBien.comments,
    );
  }
}
